import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants';
import { ISaleRoFields, IDetailList, ISaleSoDetails } from './bmsBillSaleRoType';
import { saleRoService } from './bmsBillSaleRoService';
import { forFind, formatNum } from '@/utils/utils';
import {
	IVRM2DictDetail,
	IVRM2DictSearchs,
} from '@/views/vrmBill/vrmBillSaleRo/vrmBillSaleRoService';
import useStorageState from '@/hooks/useStorageState';

type dictObj = {
	[key: string]: any;
};

function listChangeTree(list: IVRM2DictDetail[]) {
	let menuObj: dictObj = {};
	list.forEach((item) => {
		item.children = [];
		menuObj[item.code] = item;
	});
	return list.filter((item) => {
		if (item.pcode !== null && item.pcode !== '') {
			menuObj[item.pcode]?.children.push(item);
			return false;
		}
		return true;
	});
}

export type ISaleRoDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	discountAll: number;
	receivableAll: number;
	[key: string]: any;
};
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends ISaleSoDetails {
	num: number;
	// price?: number,
	// amount?: number,
	saleNum?: number;
	salePrice?: number;
	saleTotal?: number;
}
export const useBmsSaleRoDetailModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		discountAll: 0, //折扣,
		receivableAll: 0, //应收
	};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const [treeSource, setTreeSource, clearTreeSource] = useStorageState<IVRM2DictDetail[]>(
		'bmsDictTree',
		[]
	); //字典数据源
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<ISaleRoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<ISaleRoDescType>(initDesc);
	useEffect(() => {
		let newDesc: ISaleRoDescType = initDesc;
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.amount);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList, detailLookForm]);

	// 获取客车系统的数据字典
	const loadBmsDictData = async (shopCodes?: string) => {
		let data: IVRM2DictSearchs = {
			sourceApp: 'bms',
			pageSize: 10000000,
			pageNum: 1,
		};
		// let { retData } = await saleRoService.pages(data);
		// let { records } = retData;
		// setTreeSource(listChangeTree(records));
		setTreeSource(listChangeTree([]));
	};

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await saleRoService.one(id);
		if (retData) {
			const { details, settleDetails, ...from } = retData;
			const newDetails = details?.map((item) => {
				return {
					...item,
					notAmount: +formatNum(Number(item.num) * Number(item.price)),
					unitName: getBmsTreeNodeName(item.unitName as string),
				};
			});
			setDetailLookForm({
				...from,
				customerTypeName: getBmsTreeNodeName(from.customerTypeCode as string),
				siteInformation: getBmsTreeNodeName(from.siteInformation as string),
				settlementPartyName: getBmsTreeNodeName(from.settlementPartyCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				vehicleTypeName: getBmsTreeNodeName(from.vehicleTypeCode as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
			});
			setDetailLookList((newDetails as IDetailList[]) ?? []);
		}
	};

	//根据code 返回对应的node节点名称
	const getBmsTreeNodeName = (code: string): string => {
		let obj: dictObj = {};
		let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, 'code');
		return findTree ? findTree['name'] : '';
	};
	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailLookList([]);
	};

	return {
		detailLookForm,
		detailLookList,
		lookDesc,
		treeSource,
		// model
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
		getBmsTreeNodeName,
		loadBmsDictData,
	};
});
